export default __webpack_public_path__ + "static/media/edsdough.c1a00fc3.svg";